function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import animated from '../lib/hoc/withAnimation';
import { withSpacing } from '../lib/hoc/withSpacing';
import { shade, themify } from '../styles/mixins';
const StyledIcon = styled.svg.withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "kyl50l-0"
})(["display:", ";vertical-align:", ";line-height:1;width:", " !important;height:", " !important;max-width:100%;max-height:100%;transform:", ";transition:all 0.15s ", ";", ";& *{transition:fill 0.15s,stroke 0.15s;stroke-width:", " !important;}"], x => x.$inline ? 'inline-block' : 'block', x => x.$verticalAlign, x => x.$width, x => x.$height || 'auto', x => `rotate(${x.$rotate}deg)`, x => x.theme.curves.standard, x => !x.$hoverColor && x.onClick && (x.$fill || x.$stroke) && css(["cursor:pointer;&:hover{& *{", ";", ";}}"], x.$fill && css(["fill:", " !important;"], shade(0.95, x.$fill || 'grayDarker')), x.$stroke && css(["stroke:", " !important;"], shade(0.85, x.$stroke || 'grayDarker'))), x => x.$strokeWidth);
const SolidIcon = styled(StyledIcon).withConfig({
  displayName: "Icon__SolidIcon",
  componentId: "kyl50l-1"
})(["& *{stroke:", " !important;fill:", " !important;}", ";"], x => x.$stroke || 'none', x => x.$fill, x => x.$hoverColor && css(["cursor:pointer;&:hover{& *{fill:", " !important;}}"], x.$hoverColor));
const LineIcon = styled(StyledIcon).withConfig({
  displayName: "Icon__LineIcon",
  componentId: "kyl50l-2"
})(["& *{stroke:", " !important;fill:", " !important;}", ";"], x => x.$stroke, x => x.$fill || 'none', x => x.$hoverColor && css(["cursor:pointer;&:hover{& *{stroke:", " !important;}}"], x.$hoverColor));

const IconFunc = (_ref) => {
  let {
    fill,
    height,
    hoverColor,
    icon,
    inline = true,
    onClick,
    rotate = 0,
    solid,
    stroke,
    strokeWidth,
    title,
    verticalAlign = 'middle',
    width = '1em'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["fill", "height", "hoverColor", "icon", "inline", "onClick", "rotate", "solid", "stroke", "strokeWidth", "title", "verticalAlign", "width"]);

  // The generated icons need to be called as a function in order to get the component for some reason.
  // Checking type === function just in case something else is passed as icon
  const IconElement = typeof icon === 'function' ? icon(_objectSpread(_objectSpread({}, icon.defaultProps), {}, {
    solid: solid != null ? solid : icon.defaultProps.solid
  })) : /*#__PURE__*/React.createElement(icon, {
    solid
  });
  const iconProps = {
    $fill: themify(fill),
    $height: height,
    $hoverColor: themify(hoverColor),
    $inline: inline,
    $rotate: rotate,
    $solid: !!IconElement.props.solid,
    $stroke: themify(stroke),
    $strokeWidth: !!IconElement.props.solid ? 0 : strokeWidth || 2,
    $verticalAlign: verticalAlign,
    $width: width,
    icon
  };
  return /*#__PURE__*/React.createElement("span", {
    title: title
  }, solid ? /*#__PURE__*/React.createElement(SolidIcon, _extends({
    onClick: onClick
  }, iconProps, rest, IconElement.props)) : /*#__PURE__*/React.createElement(LineIcon, _extends({
    onClick: onClick
  }, iconProps, rest, IconElement.props)));
};

export const Icon = animated(withSpacing(IconFunc));